import { defineMessages } from '@/i18n';

export const appMessages = defineMessages({
  refreshButtonLabel: 'storefront.app.refresh.buttonLabel',
  refreshBannerTitle: 'storefront.app.refresh.bannerTitle',
});
